import React from 'react'
import { Button, Tooltip, Position, Icon, Intent, AnchorButton } from '@blueprintjs/core'
const ButtonText = ({ text, badge }) => {
  return (
    <div className='button-badge-wrapper'>
      {text && <span>{text}</span>}
      {badge && <small className={`button-badge  ${checkBadgeisFull(badge) && 'full'}`}>{checkBadgeisFull(badge) ? '99' : badge}</small>}
    </div>
  )
}
// TODO: bu bileşen numara baz alınarak tasarlanmıştır. text için genişletilebilir.
const checkBadgeisFull = (badge) => {
  return typeof badge === 'number' && badge >= 99
}
const BPBadgeButton = ({
  type,
  className,
  label,
  intent,
  tooltip,
  icon,
  iconSize,
  rightIcon,
  minimal,
  small,
  large,
  outlined,
  onClick,
  disabled,
  fill,
  href,
  target,
  badge,
}) => {
  const anchorOrButton = href ? (
    <AnchorButton
      href={href}
      target={`${target || '_blank'}`}
      className={`${className || 'bp3AnchorButton'}`}
      icon={<Icon icon={icon} iconSize={iconSize || 14} />}
      rightIcon={rightIcon || null}
      intent={intent || Intent.NONE}
      disabled={disabled}
      text={<ButtonText text={label} badge={badge} />}
      small={small}
      large={large}
      minimal={minimal}
      outlined={outlined}
      fill={fill}
      onClick={onClick}
    />
  ) : (
    <Button
      disabled={disabled}
      type={type}
      className={className}
      icon={<Icon icon={icon} iconSize={iconSize || 14} />}
      rightIcon={rightIcon || null}
      intent={intent || Intent.NONE}
      text={<ButtonText text={label} badge={badge} />}
      small={small}
      large={large}
      minimal={minimal}
      outlined={outlined}
      fill={fill}
      onClick={onClick}
    />
  )

  return (
    <Tooltip popoverClassName='blueprintTooltip' content={tooltip} position={Position.BOTTOM} disabled={tooltip == null || tooltip === ''}>
      {anchorOrButton}
    </Tooltip>
  )
}

export default BPBadgeButton
